import { render, staticRenderFns } from "./CarsTable.vue?vue&type=template&id=cdee1cec&"
import script from "./CarsTable.vue?vue&type=script&lang=ts&"
export * from "./CarsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports